'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import Grid from '@enlighten/design-system/dist/Grid';
import { useInView } from 'motion/react';
import { useEffect, useRef } from 'react';
import { useOnChangeSticky } from '../StickyProvider';
export default function NonStickyView({ children }) {
    const inViewRef = useRef(null);
    const inView = useInView(inViewRef);
    const onChangeSticky = useOnChangeSticky();
    useEffect(() => {
        onChangeSticky(!inView);
    }, [onChangeSticky, inView]);
    return (_jsx(Grid, { component: "div", ref: inViewRef, container: true, direction: "column", width: "100%", children: children }));
}
